<template>
    <div class="invest-planner">
        <div v-if="displayTar == ''">
            <el-tabs v-model="activeName" @tab-click="handleClick" v-if="savings.user">
                <el-tab-pane :label="$t('planner.RealEstateStrategy')" name="investStrategy">
                    <investStrategy
                        :collection="collection"
                        :savings="savings"
                        @goTo="goTo"
                        @linkToPID="linkToPID"
                        @deleteTar="deleteTar"
                        @addProperty="addProperty"
                    />
                </el-tab-pane>
                <el-tab-pane :lazy="true" :label="$t('planner.Assets')" name="investAsset">
                    <investAsset :collection="collection" :savings="savings" @goTo="goTo" />
                </el-tab-pane>
            </el-tabs>
        </div>

        <div v-if="displayTar != ''" class="border-gap">
            <a class="backToInvest" @click="displayTar = ''">{{$t('planner.BackToPlanner')}}</a>
            <el-row v-if="displayTar != ''">
                <el-col :xs="24" :sm="24" :md="12">
                    <div class="popup-box">
                        <createTar
                            :requestParams="requestParams"
                            :requestHeaders="requestHeaders"
                            :savings="savings"
                            :collection="collection"
                            @goTo="goTo"
                            v-if="displayTar == 'addTar' && savings.user"
                        />
                        <editTar
                            :requestParams="requestParams"
                            :requestHeaders="requestHeaders"
                            :savings="savings"
                            :collection="collection"
                            @goTo="goTo"
                            v-if="displayTar == 'editTar' && savings.user"
                        />
                        <adjustForecasts
                            :requestParams="requestParams"
                            :requestHeaders="requestHeaders"
                            :savings="savings"
                            @goTo="goTo"
                            v-if="displayTar == 'adjustForecasts' && savings.user"
                        />
                        <wealthAllocation
                            :requestParams="requestParams"
                            :requestHeaders="requestHeaders"
                            :savings="savings"
                            :collection="collection"
                            @goTo="goTo"
                            v-if="displayTar == 'wealthAllocation' && savings.user"
                        />
                    </div>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12"></el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import { Message } from "element-ui";
import investStrategy from "@/components/account/investStrategy.vue";
import investAsset from "@/components/account/investAsset.vue";
import editTar from "@/components/account/editTar.vue";
import createTar from "@/components/account/createTar.vue";
import adjustForecasts from "@/components/account/adjustForecasts.vue";
import wealthAllocation from "@/components/account/wealthAllocation.vue";
let loading;

export default {
    name: "investPlannerContainer",
    props: [
        "requestParams",
        "requestHeaders",
        "propertySelector",
        "browser_currency_symbol"
    ],
    data() {
        const $t = this.$t.bind(this);
        return {
            activeName: "investStrategy",
            collection: {},
            cities: {},
            savings: {},
            displayTar: ""
        };
    },
    beforeMount() {
        this.initialData();
    },

    mounted() {},

    methods: {
        initialData() {
            let getStrategy = `${this.requestParams.ppbApi}api/savings/strategy/`;
            let savings = `${this.requestParams.ppbApi}api/savings`;

            this.$http
                .get(getStrategy, this.requestHeaders)
                .then(result => {
                    this.collection = result.data;
                })
                .then(
                    this.$http
                        .get(savings, this.requestHeaders)
                        .then(result => {
                            this.savings = result.data;
                            this.$emit("loaded", true);
                        })
                        .catch(err => {})
                )
                .catch(err => {});
        },

        goTo(tar) {
            this.displayTar = tar;
            // back to the top of browser
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
            this.initialData();
        },

        addProperty() {
            this.$emit("addProperty", "addProperty");
        },

        linkToPID(data) {
            this.$emit("linkToPID", data);
        },

        deleteTar(data) {
            let deteleTarUrl = `${this.requestParams.ppbApi}api/savings/investment/${data.id}`;

            this.loading();

            this.$http.delete(deteleTarUrl, this.requestHeaders).then(resp => {
                if (resp.data.status == "success") {
                    this.triggerMessage("success", {
                        message: this.$t("planner.delete_s")
                    });
                    this.initialData();
                } else {
                    this.triggerMessage("error", {
                        message: this.$t("planner.delete_err")
                    });
                }
                loading.close();
            });
        },

        triggerMessage(type, options) {
            options.duration = 6000;
            return Message[type](options);
        },

        loading() {
            loading = this.$loading({
                lock: true,
                target: ".main-container",
                text: this.$t("searchResultPage.loading"),
                color: "#3b6bbf",
                background: "rgba(255, 255, 255, 0.8)"
            });
        },

        handleClick(tab, event) {
            // console.log(tab, event);
        }
    },

    filters: {},

    watch: {},

    components: {
        investStrategy,
        investAsset,
        editTar,
        createTar,
        adjustForecasts,
        wealthAllocation
    }
};
</script>
<style lang="scss">
.invest-planner {
    .border-gap {
        padding: 30px;
        @media (max-width: 414px) {
            padding: 16px;
        }
    }
    .el-tabs__header {
        margin-bottom: 20px;
    }
    .el-tabs__content {
        padding: 0 28px;
        @media (max-width: 414px) {
            padding: 0;
        }
    }
    .el-tabs__nav-scroll {
        padding: 0 40px;
        .el-tabs__active-bar {
            background-color: var(--windows-blue);
        }
    }
    .el-tabs__item {
        height: 54px;
        line-height: 54px;
        font-family: GothamBook;
        font-size: 14px;
        text-align: center;
        color: #121212;
        opacity: 0.5;
        &.is-active {
            font-family: GothamMedium;
            opacity: 1;
            font-weight: 500;
        }
    }
    .backToInvest {
        font-family: GothamBook;
        display: inline-block;
        margin-bottom: 30px;
        font-size: 14px;
        color: var(--windows-blue);
        &::before {
            content: "";
            display: inline-block;
            width: 15px;
            height: 12px;
            margin-right: 9px;
            background: url("../../../../website_20/static/img/icon-arrow-l-blue.svg")
                no-repeat;
            background-size: contain;
        }
    }
    .popup-box {
        h3 {
            font-family: GothamMedium;
            font-size: 16px;
            line-height: 1;
            color: #2e384d;
            margin-bottom: 20px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/account/investPlannerContainer.vue